export enum BuildingType {
    ADMINISTRATION = 'administration',
    APARTMENT = 'apartment',
    DATA_CENTER = 'data-center',
    DATA_CENTER_COOLING_AIR = 'data-center-cooling-air',
    DATA_CENTER_COOLING_DIRECT = 'data-center-cooling-direct',
    DATA_CENTER_COOLING_LIQUID = 'data-center-cooling-liquid',
    FACTORY = 'factory',
    FACTORY_HEATING = 'factory-heating',
    FACTORY_PRODUCTION = 'factory-production',
    FACTORY_SPRINKLER_CENTER = 'factory-sprinkler-center',
    FACTORY_PROCESSES = 'factory-processes',
    INDUSTRY = 'industry',
    INDUSTRY_LAB = 'industry-lab',
    INDUSTRY_PRODUCTION = 'industry-production',
    INDUSTRY_WATER = 'industry-water',
    INDUSTRY_TESTCENTER = 'industry-testcenter',
    INDUSTRY_SPRINKLER_CENTER = 'industry-sprinkler-center',
    INDUSTRY_HEATING = 'industry-heating',
    HOUSE = 'house',
    HOSPITAL = 'hospital',
    SCHOOL = 'school',
    SKYSCRAPER = 'skyscraper',
    SKYSCRAPER_WATER_UPPER = 'skyscraper-water-upper',
    SKYSCRAPER_WATER_LOWER = 'skyscraper-water-lower',
    KSB_CENTER = 'ksbCenter',
    HOTEL = 'hotel',
    KSB_QUICKLINKS = 'ksb-quicklinks',
    KSB_TEAM = 'ksbTeam',
}
